import { HolisticStudent, DashboardKPI, CompetencyDistribution, InterestCategory, AttendanceTrend, ObservationSentiment } from '../types';

// ---- Mock Students ----
export const mockStudents: HolisticStudent[] = [
  {
    id: 'STU001', name: 'Aarav Sharma', className: 'Class 5', section: 'A', rollNo: 1, gender: 'Male',
    academicYear: '2025-26',
    physical: { height: 125, weight: 28, bmi: 17.9, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Very social and friendly',
      self_with_friends_t2: 'Has become more confident in groups',
      self_find_difficult_t1: 'Mathematics word problems',
      self_find_difficult_t2: 'Still finds long division challenging',
      self_enjoy_most_t1: 'Drawing and painting',
      self_enjoy_most_t2: 'Sports and outdoor activities',
    },
    peer: {
      peer_shares_stn_t1: 'Always shares stationery', peer_shares_stn_t2: 'Shares willingly',
      peer_likes_play_t1: 'Cricket and badminton', peer_likes_play_t2: 'Football added',
      peer_helps_task_t1: 'Helps classmates with art projects',
    },
    parentFeedback: {
      parent_support_t1: 'Very supportive', parent_support_t2: 'Continued support',
      parent_share_t1: 'Shares school stories daily', parent_share_t2: 'Still very communicative',
      parent_enjoys_t1: 'Enjoys reading at home', parent_enjoys_t2: 'Started puzzle solving',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Creative thinking, Art skills', lp_strengths_t2: 'Leadership qualities emerging',
      lp_challenges_t1: 'Needs focus on Math', lp_challenges_t2: 'Improving steadily',
      lp_observations_t1: 'Active participant in class', lp_observations_t2: 'Shows initiative in group work',
      lp_suggestions_t1: 'Extra math practice', lp_suggestions_t2: 'Encourage leadership roles',
    },
    interests: {
      things_i_like: 'Drawing, Cricket, Reading comics',
      favourite_games: 'Cricket', favourite_food: 'Pizza', favourite_colour: 'Blue',
      favourite_animals: 'Dog', friends_are: 'Rohit, Priya, Karan', i_live_in: 'Urban area',
    },
    academic: { term1_competency: 78, term2_competency: 85, academicYear: '2025-26', classID: '5A' },
    attendance: { daysAttendedPerMonth: { Apr: 22, May: 20, Jun: 18, Jul: 23, Aug: 21, Sep: 20, Oct: 22, Nov: 19, Dec: 16, Jan: 21, Feb: 20, Mar: 18 } },
    averageCompetency: 81.5,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 82, peerScore: 88, attendancePercentage: 92, competencyLevel: 'Good', needsSupport: false,
  },
  {
    id: 'STU002', name: 'Priya Patel', className: 'Class 5', section: 'A', rollNo: 2, gender: 'Female',
    academicYear: '2025-26',
    physical: { height: 122, weight: 25, bmi: 16.8, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Quiet but helpful', self_with_friends_t2: 'Opening up more',
      self_find_difficult_t1: 'Public speaking', self_find_difficult_t2: 'Still shy in presentations',
      self_enjoy_most_t1: 'Reading stories', self_enjoy_most_t2: 'Science experiments',
    },
    peer: {
      peer_shares_stn_t1: 'Shares when asked', peer_shares_stn_t2: 'More proactive sharing',
      peer_likes_play_t1: 'Skipping rope', peer_likes_play_t2: 'Kho-kho',
      peer_helps_task_t1: 'Helps with reading activities',
    },
    parentFeedback: {
      parent_support_t1: 'Moderate support', parent_support_t2: 'Increased involvement',
      parent_share_t1: 'Shares occasionally', parent_share_t2: 'More open now',
      parent_enjoys_t1: 'Enjoys cooking with mother', parent_enjoys_t2: 'Gardening',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Excellent reader, Attentive', lp_strengths_t2: 'Strong in Science',
      lp_challenges_t1: 'Needs confidence building', lp_challenges_t2: 'Improving in group participation',
      lp_observations_t1: 'Very attentive but reserved', lp_observations_t2: 'Volunteering more often',
      lp_suggestions_t1: 'Assign speaking roles', lp_suggestions_t2: 'Pair with outgoing students',
    },
    interests: {
      things_i_like: 'Reading, Science, Cooking',
      favourite_games: 'Kho-Kho', favourite_food: 'Dal Chawal', favourite_colour: 'Pink',
      favourite_animals: 'Cat', friends_are: 'Aarav, Meera, Sita', i_live_in: 'Suburban area',
    },
    academic: { term1_competency: 88, term2_competency: 91, academicYear: '2025-26', classID: '5A' },
    attendance: { daysAttendedPerMonth: { Apr: 21, May: 22, Jun: 20, Jul: 22, Aug: 23, Sep: 21, Oct: 23, Nov: 20, Dec: 17, Jan: 22, Feb: 21, Mar: 19 } },
    averageCompetency: 89.5,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 75, peerScore: 72, attendancePercentage: 95, competencyLevel: 'Excellent', needsSupport: false,
  },
  {
    id: 'STU003', name: 'Rohit Kumar', className: 'Class 4', section: 'B', rollNo: 5, gender: 'Male',
    academicYear: '2025-26',
    physical: { height: 118, weight: 30, bmi: 21.5, bmiCategory: 'Overweight' },
    behavior: {
      self_with_friends_t1: 'Energetic and playful', self_with_friends_t2: 'Sometimes overexcited',
      self_find_difficult_t1: 'Sitting still in class', self_find_difficult_t2: 'Concentration issues',
      self_enjoy_most_t1: 'Playing games', self_enjoy_most_t2: 'Physical education',
    },
    peer: {
      peer_shares_stn_t1: 'Shares reluctantly', peer_shares_stn_t2: 'Getting better at sharing',
      peer_likes_play_t1: 'Football', peer_likes_play_t2: 'Basketball',
      peer_helps_task_t1: 'Helps in sports activities',
    },
    parentFeedback: {
      parent_support_t1: 'Low engagement', parent_support_t2: 'Slightly improved',
      parent_share_t1: 'Does not share much', parent_share_t2: 'Started talking about school',
      parent_enjoys_t1: 'Watching TV', parent_enjoys_t2: 'Playing mobile games',
      parent_vaccine_t1: 'Partially vaccinated', parent_vaccine_t2: 'Completed now',
    },
    teacherObservation: {
      lp_strengths_t1: 'High energy, Sports talent', lp_strengths_t2: 'Natural leader in games',
      lp_challenges_t1: 'Concentration, Written work', lp_challenges_t2: 'Still needs focus improvement',
      lp_observations_t1: 'Disruptive at times but means well', lp_observations_t2: 'Channeling energy better',
      lp_suggestions_t1: 'Structured activities, Fidget tools', lp_suggestions_t2: 'Continue positive reinforcement',
    },
    interests: {
      things_i_like: 'Football, TV, Video games',
      favourite_games: 'Football', favourite_food: 'Burger', favourite_colour: 'Red',
      favourite_animals: 'Horse', friends_are: 'Vikram, Aarav', i_live_in: 'Rural area',
    },
    academic: { term1_competency: 52, term2_competency: 58, academicYear: '2025-26', classID: '4B' },
    attendance: { daysAttendedPerMonth: { Apr: 18, May: 15, Jun: 14, Jul: 19, Aug: 17, Sep: 16, Oct: 18, Nov: 15, Dec: 12, Jan: 17, Feb: 16, Mar: 14 } },
    averageCompetency: 55,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 55, peerScore: 60, attendancePercentage: 72, competencyLevel: 'Below Average', needsSupport: true,
  },
  {
    id: 'STU004', name: 'Meera Joshi', className: 'Class 6', section: 'A', rollNo: 3, gender: 'Female',
    academicYear: '2025-26',
    physical: { height: 135, weight: 32, bmi: 17.6, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Calm and supportive', self_with_friends_t2: 'Becoming a peer mentor',
      self_find_difficult_t1: 'Physical exercise', self_find_difficult_t2: 'Still dislikes running',
      self_enjoy_most_t1: 'Music and singing', self_enjoy_most_t2: 'Learning instruments',
    },
    peer: {
      peer_shares_stn_t1: 'Very generous', peer_shares_stn_t2: 'Always helps others',
      peer_likes_play_t1: 'Indoor games', peer_likes_play_t2: 'Board games',
      peer_helps_task_t1: 'Tutors weaker students',
    },
    parentFeedback: {
      parent_support_t1: 'Highly involved', parent_support_t2: 'Very engaged',
      parent_share_t1: 'Shares everything', parent_share_t2: 'Very communicative',
      parent_enjoys_t1: 'Singing at home', parent_enjoys_t2: 'Learning piano',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Empathetic, Musical talent, Good grades', lp_strengths_t2: 'Class leader, Creative',
      lp_challenges_t1: 'Physical fitness', lp_challenges_t2: 'Avoiding competitive sports',
      lp_observations_t1: 'Excellent student with all-round abilities', lp_observations_t2: 'Role model for class',
      lp_suggestions_t1: 'Encourage sports participation', lp_suggestions_t2: 'Guide towards cultural events',
    },
    interests: {
      things_i_like: 'Music, Singing, Board games',
      favourite_games: 'Chess', favourite_food: 'Pasta', favourite_colour: 'Purple',
      favourite_animals: 'Rabbit', friends_are: 'Priya, Ananya, Sita', i_live_in: 'Urban area',
    },
    academic: { term1_competency: 92, term2_competency: 95, academicYear: '2025-26', classID: '6A' },
    attendance: { daysAttendedPerMonth: { Apr: 23, May: 22, Jun: 21, Jul: 23, Aug: 22, Sep: 22, Oct: 23, Nov: 21, Dec: 18, Jan: 23, Feb: 22, Mar: 20 } },
    averageCompetency: 93.5,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 95, peerScore: 96, attendancePercentage: 97, competencyLevel: 'Excellent', needsSupport: false,
  },
  {
    id: 'STU005', name: 'Vikram Singh', className: 'Class 4', section: 'A', rollNo: 8, gender: 'Male',
    academicYear: '2025-26',
    physical: { height: 115, weight: 22, bmi: 16.6, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Friendly and outgoing', self_with_friends_t2: 'Making more friends',
      self_find_difficult_t1: 'Writing essays', self_find_difficult_t2: 'Grammar rules',
      self_enjoy_most_t1: 'Building things', self_enjoy_most_t2: 'Science projects',
    },
    peer: {
      peer_shares_stn_t1: 'Shares eagerly', peer_shares_stn_t2: 'Very cooperative',
      peer_likes_play_t1: 'Cricket', peer_likes_play_t2: 'Kabaddi',
      peer_helps_task_t1: 'Helps with hands-on activities',
    },
    parentFeedback: {
      parent_support_t1: 'Supportive', parent_support_t2: 'Consistent involvement',
      parent_share_t1: 'Talks about school', parent_share_t2: 'Shares daily progress',
      parent_enjoys_t1: 'Building model kits', parent_enjoys_t2: 'Watching documentaries',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Curious mind, Hands-on learner', lp_strengths_t2: 'Problem solver, Innovative',
      lp_challenges_t1: 'Written expression', lp_challenges_t2: 'Spelling and grammar',
      lp_observations_t1: 'Excels in practical activities', lp_observations_t2: 'Growing interest in Science',
      lp_suggestions_t1: 'Journal writing practice', lp_suggestions_t2: 'Science club enrollment',
    },
    interests: {
      things_i_like: 'Building things, Science, Cricket',
      favourite_games: 'Cricket', favourite_food: 'Biryani', favourite_colour: 'Green',
      favourite_animals: 'Eagle', friends_are: 'Rohit, Aarav, Dev', i_live_in: 'Semi-urban area',
    },
    academic: { term1_competency: 68, term2_competency: 74, academicYear: '2025-26', classID: '4A' },
    attendance: { daysAttendedPerMonth: { Apr: 20, May: 21, Jun: 19, Jul: 22, Aug: 20, Sep: 19, Oct: 21, Nov: 18, Dec: 15, Jan: 20, Feb: 19, Mar: 17 } },
    averageCompetency: 71,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 78, peerScore: 82, attendancePercentage: 88, competencyLevel: 'Good', needsSupport: false,
  },
  {
    id: 'STU006', name: 'Ananya Reddy', className: 'Class 6', section: 'B', rollNo: 12, gender: 'Female',
    academicYear: '2025-26',
    physical: { height: 132, weight: 29, bmi: 16.6, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Shy but caring', self_with_friends_t2: 'Becoming more expressive',
      self_find_difficult_t1: 'Group activities', self_find_difficult_t2: 'Still prefers solo work',
      self_enjoy_most_t1: 'Art and crafts', self_enjoy_most_t2: 'Dance',
    },
    peer: {
      peer_shares_stn_t1: 'Shares with close friends', peer_shares_stn_t2: 'Expanding circle',
      peer_likes_play_t1: 'Hopscotch', peer_likes_play_t2: 'Dance activities',
      peer_helps_task_t1: 'Helps in art projects',
    },
    parentFeedback: {
      parent_support_t1: 'Very supportive', parent_support_t2: 'Highly engaged',
      parent_share_t1: 'Shares with mother', parent_share_t2: 'Both parents involved',
      parent_enjoys_t1: 'Dance practice', parent_enjoys_t2: 'Craft work',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Artistic talent, Detail oriented', lp_strengths_t2: 'Creative expression, Dance skill',
      lp_challenges_t1: 'Social anxiety in large groups', lp_challenges_t2: 'Gradually improving',
      lp_observations_t1: 'Talented in arts, needs social encouragement', lp_observations_t2: 'Dance has boosted confidence',
      lp_suggestions_t1: 'Small group activities', lp_suggestions_t2: 'Drama club participation',
    },
    interests: {
      things_i_like: 'Art, Dance, Crafts',
      favourite_games: 'Hide and Seek', favourite_food: 'Dosa', favourite_colour: 'Yellow',
      favourite_animals: 'Butterfly', friends_are: 'Meera, Priya', i_live_in: 'Urban area',
    },
    academic: { term1_competency: 72, term2_competency: 79, academicYear: '2025-26', classID: '6B' },
    attendance: { daysAttendedPerMonth: { Apr: 21, May: 20, Jun: 19, Jul: 22, Aug: 21, Sep: 20, Oct: 22, Nov: 19, Dec: 16, Jan: 21, Feb: 20, Mar: 18 } },
    averageCompetency: 75.5,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 70, peerScore: 65, attendancePercentage: 90, competencyLevel: 'Good', needsSupport: false,
  },
  {
    id: 'STU007', name: 'Karan Mehta', className: 'Class 3', section: 'A', rollNo: 4, gender: 'Male',
    academicYear: '2025-26',
    physical: { height: 108, weight: 19, bmi: 16.3, bmiCategory: 'Normal' },
    behavior: {
      self_with_friends_t1: 'Very talkative', self_with_friends_t2: 'Class entertainer',
      self_find_difficult_t1: 'Following instructions', self_find_difficult_t2: 'Completing homework',
      self_enjoy_most_t1: 'Telling stories', self_enjoy_most_t2: 'Acting in plays',
    },
    peer: {
      peer_shares_stn_t1: 'Shares happily', peer_shares_stn_t2: 'Very generous',
      peer_likes_play_t1: 'Tag games', peer_likes_play_t2: 'Hide and seek',
      peer_helps_task_t1: 'Entertains and motivates peers',
    },
    parentFeedback: {
      parent_support_t1: 'Moderate support', parent_support_t2: 'Trying harder',
      parent_share_t1: 'Very talkative at home', parent_share_t2: 'Non-stop stories',
      parent_enjoys_t1: 'Watching cartoons', parent_enjoys_t2: 'Making up stories',
      parent_vaccine_t1: 'Fully vaccinated', parent_vaccine_t2: 'Up to date',
    },
    teacherObservation: {
      lp_strengths_t1: 'Communication skills, Creativity', lp_strengths_t2: 'Public speaking, Story telling',
      lp_challenges_t1: 'Discipline, Task completion', lp_challenges_t2: 'Still needs structure',
      lp_observations_t1: 'Bright but needs channeling of energy', lp_observations_t2: 'Dramatic talent noticed',
      lp_suggestions_t1: 'Theatre club, Structured tasks', lp_suggestions_t2: 'Debate competitions',
    },
    interests: {
      things_i_like: 'Stories, Acting, Cartoons',
      favourite_games: 'Tag', favourite_food: 'Ice Cream', favourite_colour: 'Orange',
      favourite_animals: 'Monkey', friends_are: 'Everyone in class', i_live_in: 'Urban area',
    },
    academic: { term1_competency: 62, term2_competency: 65, academicYear: '2025-26', classID: '3A' },
    attendance: { daysAttendedPerMonth: { Apr: 19, May: 18, Jun: 17, Jul: 20, Aug: 19, Sep: 18, Oct: 20, Nov: 17, Dec: 14, Jan: 19, Feb: 18, Mar: 16 } },
    averageCompetency: 63.5,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 65, peerScore: 85, attendancePercentage: 80, competencyLevel: 'Average', needsSupport: false,
  },
  {
    id: 'STU008', name: 'Sita Devi', className: 'Class 5', section: 'B', rollNo: 6, gender: 'Female',
    academicYear: '2025-26',
    physical: { height: 120, weight: 20, bmi: 13.9, bmiCategory: 'Underweight' },
    behavior: {
      self_with_friends_t1: 'Withdrawn', self_with_friends_t2: 'Slowly engaging',
      self_find_difficult_t1: 'Everything feels hard', self_find_difficult_t2: 'English comprehension',
      self_enjoy_most_t1: 'Helping mother', self_enjoy_most_t2: 'Drawing flowers',
    },
    peer: {
      peer_shares_stn_t1: 'Does not interact much', peer_shares_stn_t2: 'Making one friend',
      peer_likes_play_t1: 'Alone play', peer_likes_play_t2: 'Starting to join groups',
      peer_helps_task_t1: 'Quiet helper when asked',
    },
    parentFeedback: {
      parent_support_t1: 'Low engagement', parent_support_t2: 'No change',
      parent_share_t1: 'Rarely shares', parent_share_t2: 'Still withdrawn at home',
      parent_enjoys_t1: 'Household chores', parent_enjoys_t2: 'Drawing',
      parent_vaccine_t1: 'Partially vaccinated', parent_vaccine_t2: 'Getting updated',
    },
    teacherObservation: {
      lp_strengths_t1: 'Obedient, Sincere', lp_strengths_t2: 'Artistic potential',
      lp_challenges_t1: 'Language barrier, Social skills', lp_challenges_t2: 'Nutrition and health concerns',
      lp_observations_t1: 'Needs nurturing environment and support', lp_observations_t2: 'Responding to one-on-one attention',
      lp_suggestions_t1: 'Counselor referral, Nutritional support', lp_suggestions_t2: 'Continue mentor pairing',
    },
    interests: {
      things_i_like: 'Drawing, Helping at home',
      favourite_games: 'Doll play', favourite_food: 'Roti Sabzi', favourite_colour: 'White',
      favourite_animals: 'Cow', friends_are: 'Meera', i_live_in: 'Rural area',
    },
    academic: { term1_competency: 42, term2_competency: 48, academicYear: '2025-26', classID: '5B' },
    attendance: { daysAttendedPerMonth: { Apr: 15, May: 14, Jun: 12, Jul: 16, Aug: 14, Sep: 13, Oct: 15, Nov: 12, Dec: 10, Jan: 14, Feb: 13, Mar: 11 } },
    averageCompetency: 45,
    photos: { photo_myself: '/placeholder-student.png' },
    behaviorScore: 45, peerScore: 35, attendancePercentage: 62, competencyLevel: 'Below Average', needsSupport: true,
  },
];

// ---- Dashboard KPIs ----
export const mockKPIs: DashboardKPI = {
  totalStudents: 1256,
  averageAttendance: 85.6,
  averageCompetency: 72.4,
  studentsNeedingSupport: 187,
  activeParticipationRate: 78.2,
};

// ---- Chart Data ----
export const competencyDistribution: CompetencyDistribution[] = [
  { level: 'Excellent', count: 312 },
  { level: 'Good', count: 456 },
  { level: 'Average', count: 328 },
  { level: 'Below Average', count: 160 },
];

export const interestCategories: InterestCategory[] = [
  { category: 'Sports', count: 420 },
  { category: 'Arts & Crafts', count: 280 },
  { category: 'Music', count: 195 },
  { category: 'Science', count: 165 },
  { category: 'Reading', count: 120 },
  { category: 'Technology', count: 76 },
];

export const attendanceTrend: AttendanceTrend[] = [
  { month: 'Apr', attendance: 94 },
  { month: 'May', attendance: 91 },
  { month: 'Jun', attendance: 85 },
  { month: 'Jul', attendance: 93 },
  { month: 'Aug', attendance: 90 },
  { month: 'Sep', attendance: 88 },
  { month: 'Oct', attendance: 92 },
  { month: 'Nov', attendance: 84 },
  { month: 'Dec', attendance: 76 },
  { month: 'Jan', attendance: 89 },
  { month: 'Feb', attendance: 87 },
  { month: 'Mar', attendance: 82 },
];

export const observationSentiment: ObservationSentiment[] = [
  { type: 'Positive', count: 845 },
  { type: 'Concern', count: 411 },
];

// AI Insights generator
export function getAIInsights(student: HolisticStudent): string[] {
  const insights: string[] = [];

  if (student.peerScore >= 80) {
    insights.push('Student demonstrates strong social interaction with peers.');
  } else if (student.peerScore < 50) {
    insights.push('Student may benefit from guided social interaction activities.');
  }

  if (student.behaviorScore < 60) {
    insights.push('Teacher observations suggest improvement needed in concentration.');
  }

  if (student.interests.favourite_games.match(/cricket|football|basketball|kabaddi|sports/i)) {
    insights.push('High interest in sports and outdoor activities.');
  }

  if (student.academic.term2_competency > student.academic.term1_competency) {
    const improvement = student.academic.term2_competency - student.academic.term1_competency;
    insights.push(`Academic competency improved by ${improvement}% from Term 1 to Term 2.`);
  }

  if (student.attendancePercentage < 75) {
    insights.push('Attendance below 75% — may need follow-up with parents.');
  }

  if (student.physical.bmiCategory === 'Underweight') {
    insights.push('Physical development indicates underweight — nutritional support recommended.');
  } else if (student.physical.bmiCategory === 'Overweight') {
    insights.push('BMI indicates overweight — encourage physical activities.');
  }

  if (student.needsSupport) {
    insights.push('This student has been flagged as needing additional support.');
  }

  if (insights.length === 0) {
    insights.push('Student is performing well across all development areas.');
  }

  return insights;
}
